module.exports = __webpack_public_path__ + "static/pfmicon-af84d8f8751f6f56135aad0f77d5e48a.png";